export const USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';
export const CODE_MISMATCH_EXCEPTION = 'CodeMismatchException';
